import { Link, useNavigate } from "react-router-dom";
import { OnedaybiotechLogo, LogoutIcon, ProfileIcon } from "../assets/img";
import { useState } from "react";
import { useAuth } from "../providers/auth";
import Login from "../pages/Login/Login";
import Cookies from "js-cookie";
import Modal from "../components/ui/Modal/Modal";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

const navigation = [
  { name: "대시보드", href: "/", current: true },
  {
    name: "회원관리",
    href: "/hospital",
    current: false,
    subMenu: [
      { name: "회원조회", href: "/hospital" },
      { name: "푸시알림 발송", href: "/push-notification" },
    ],
  },
  {
    name: "상품관리",
    href: "/product-management/product-group",
    current: false,
    subMenu: [
      { name: "상품조회", href: "/product-management/product-group" },
      { name: "상품등록", href: "/product-management/registration" },
      { name: "카테고리", href: "/product-management/category" },
      { name: "코드관리", href: "/product-management/code" },
      { name: "재고관리", href: "/product-management/inventory" },
    ],
  },
  {
    name: "주문관리",
    href: "/order-management",
    current: false,
    subMenu: [
      { name: "주문내역 관리", href: "/order-management" },
      { name: "불량접수 관리", href: "/defect-reception" },
      { name: "세금계산서", href: "/tax-invoices" },
    ],
  },
  { name: "게시판관리", href: "/bulletin-board", current: false },
  { name: "배너관리", href: "/banner-management", current: false },
  { name: "통계", href: "/statistic", current: false },
  { name: "정책&약관관리", href: "/terms-and-condition", current: false },
  {
    name: "테스트",
    href: "/external-service-test",
    current: false,
    subMenu: [{ name: "외부서비스연동", href: "/external-service-test" }],
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function MainLayout({ children }) {
  const { logout, isAuth } = useAuth();
  const navigate = useNavigate();
  const [navigationState, setNavigationState] = useState(navigation);
  const currentMenu = localStorage.getItem("currentMenu");
  const currentSubMenu = localStorage.getItem("currentSubMenu");
  const token = Cookies.get("session");

  const handleClick = (index, item, subHref) => {
    const newNavigationState = [...navigationState];
    newNavigationState.forEach((item, i) => {
      item.current = i === index;
    });
    localStorage.setItem("currentMenu", item.href);
    if (subHref) {
      localStorage.setItem("currentSubMenu", subHref);
    } else {
      if (item?.subMenu) {
        localStorage.setItem("currentSubMenu", item?.subMenu[0]?.href);
      } else {
        localStorage.removeItem("currentSubMenu");
      }
    }
    setNavigationState(newNavigationState);
  };

  const handleLogout = async () => {
    await logout(token);
  };

  return (
    <>
      {isAuth ? (
        <div>
          <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-68 lg:flex-col">
            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-primary-blue px-6 pb-2">
              <div className="flex h-14 pl-1 pr-5 shrink-0 mt-0.5 items-center">
                <img
                  className="w-[10.5rem]"
                  src={OnedaybiotechLogo}
                  alt="Your Company"
                />
              </div>
              <nav className="flex flex-1 flex-col">
                <ul className="flex flex-1 flex-col gap-y-6">
                  <li>
                    <ul className="space-y-5">
                      {navigationState.map((item, index) => (
                        <li key={item.name}>
                          <Link
                            to={item.href}
                            onClick={() => handleClick(index, item)}
                            className={classNames(
                              item.href === currentMenu
                                ? "font-bold text-white"
                                : "text-secondary-grey",
                              // before: 12px
                              "group flex gap-x-3 rounded-md pt-4 pl-1.5 text-[14px] leading-6"
                            )}
                          >
                            {item.name}
                          </Link>
                          {item.subMenu && item.href === currentMenu && (
                            <ul className="space-y-4 mt-6">
                              {item.subMenu.map((subItem, index) => (
                                <li key={subItem.name}>
                                  <Link
                                    to={subItem.href}
                                    onClick={() =>
                                      handleClick(index, item, subItem?.href)
                                    }
                                    className={classNames(
                                      subItem.href === currentSubMenu
                                        ? "font-bold text-white"
                                        : "text-secondary-grey",
                                      // before 10px
                                      "group flex rounded-md pl-1.5 text-[12px] leading-6"
                                    )}
                                  >
                                    {subItem.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <div className="lg:pl-[15rem]">
            <div className="sticky px-[42px] top-0 z-40 flex justify-end h-[60px] shrink-0 items-center gap-x-4 border-b border-primary-grey bg-white w-full">
              <div
                onClick={() => navigate("/administrator-information")}
                className="cursor-pointer"
              >
                <img src={ProfileIcon} className="w-[15px]" alt="" />
              </div>
              <Modal
                description="로그아웃 하시겠습니까? 로그아웃 할 경우, 자동 로그인이 해제됩니다."
                onSubmit={handleLogout}
                submitText="로그아웃"
              >
                <div className="cursor-pointer">
                  <img src={LogoutIcon} className="w-[15px]" alt="" />
                </div>
              </Modal>
            </div>
            <main className="py-7 px-[42px]">
              <div>{children}</div>
            </main>
          </div>
        </div>
      ) : (
        <Login />
      )}
    </>
  );
}
